import { API_CONFIG } from "../config/api";
import apiService from "./api";

// Client-specific API methods using Amplify API v6 REST
export const clientApi = {
    // Get all clients
    getClients: async ({ search, sort, skip, limit }) => {
        return apiService.post(API_CONFIG.ENDPOINTS.CLIENTS, { search, sort, skip, limit, });
    },
    
    // Onboard a new client
    onboardClient: async (clientData) => {
        return apiService.post(API_CONFIG.ENDPOINTS.ONBOARD_CLIENT, clientData);
    },
    
    // Update client
    updateClient: async (clientId, clientData) => {
        return apiService.put(API_CONFIG.ENDPOINTS.UPDATE_CLIENT(clientId), clientData);
    },
    
    // Deactivate client
    deactivateClient: async (clientId) => {
        return apiService.put(API_CONFIG.ENDPOINTS.DEACTIVATE_CLIENT(clientId), { accountId: clientId });
    },

    // Delete client
    deleteClient: async (clientId) => {
        return apiService.delete(API_CONFIG.ENDPOINTS.DELETE_CLIENT(), { accountId: clientId });
    },
    
    // Get client details
    getClientDetails: async (clientId) => {
        return apiService.post(API_CONFIG.ENDPOINTS.CLIENTS, { id: clientId });
    },

    // Report
    getUsageReports: async ({ id, month, year }) => {
        return apiService.post(API_CONFIG.ENDPOINTS.CLIENTS, { id, month, year, operation: 'report' });
    },

    // Usage Stats
    getUsageStats: async ({ id, month, year }) => {
        return apiService.post(API_CONFIG.ENDPOINTS.CLIENTS, { id, month, year, operation: 'report-stats' });
    },
  };